import { css as LitCss, unsafeCSS } from 'lit';
import { defer, fromEvent, map, shareReplay, startWith } from 'rxjs';
import { subscribe } from './subscribe-reactive-controller';
const mobileMediaString = 'screen and (max-width: 610px)';
let mobileMatchMedia;
export function getMobileMatchMedia() {
    if (!mobileMatchMedia) {
        mobileMatchMedia = matchMedia(mobileMediaString);
    }
    return mobileMatchMedia;
}
export function mobileMediaCSS(style) {
    return LitCss `
      @media ${unsafeCSS(mobileMediaString)} {
          ${unsafeCSS(style)}
      }
  `;
}
const emitter$ = defer(() => fromEvent(getMobileMatchMedia(), 'change')).pipe(map(() => getMobileMatchMedia()), startWith(getMobileMatchMedia()), shareReplay({ bufferSize: 0, refCount: true }));
export function changeMobileMatchMedia(context) {
    subscribe(context, [emitter$]);
}
export function getMobileMatchMediaEmitter() {
    return emitter$;
}
export function getMobileMatchMediaAndSubscribe(context) {
    changeMobileMatchMedia(context);
    return getMobileMatchMedia();
}
//# sourceMappingURL=match-media.js.map